import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

import { BUTTON__CONTENT_CLASS, SPINNER_CLASSNAME_PREFIX } from '../constants';
import { baseButton, baseLink } from '../styles/base.styles';
import { spinnerTransitions } from '../styles/spinner.styles';

const { fonts, responsiveText } = theme;

export const solidButtonStyle = css`
  border-radius: ${pxToRem(6)};
  background-color: ${palette.deepPurpleBase};

  .${BUTTON__CONTENT_CLASS} {
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    height: ${pxToRem(28)};
    ${responsiveText.BODY.MD}
  }
`;

export const solidButton = css`
  ${baseButton}
  ${solidButtonStyle}
  ${spinnerTransitions(SPINNER_CLASSNAME_PREFIX)}

  &:disabled {
    background-color: color-mix(in srgb, ${palette.deepPurpleBase} 30%, white);
    border: 1px solid color-mix(in srgb, ${palette.deepPurpleBase} 30%, white);
    cursor: not-allowed;
    .${BUTTON__CONTENT_CLASS} {
      color: color-mix(in srgb, ${palette.greyBase} 30%, white);
    }
  }
`;

export const solidButtonLink = css`
  ${baseLink}
  ${solidButtonStyle}
  ${spinnerTransitions(SPINNER_CLASSNAME_PREFIX)}
`;

export const hoverStandard = css`
  &:hover {
    background-color: color-mix(in srgb, ${palette.deepPurpleBase} 80%, white);
  }
`;

export const hoverDarkTextModeFilter = css`
  &:hover {
    filter: brightness(1.2);
  }
`;

export const hoverLightTextModeFilter = css`
  &:hover {
    filter: brightness(0.6);
  }
`;
